import Client from '@/services/api/internal/tools/client';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';

export default function getPausedFromList(idList) {
  const url = `${process.env.P2C_BASE_URI}/dispatched_requests/count`;
  return Client.post(
    url,
    { entities: idList },
    {
      __retry: { nbLeft: 2, timeout: 2000 },
    }
  )
    .then((response) => {
      return response.data;
    })
    .catch(errorHandler);
}
